// Simple Direct Wishlist Fix
console.log('Loading simple wishlist fix...');

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM ready, initializing wishlist...');
    
    // Wait for jQuery and window objects
    function initWishlistFix() {
        if (typeof jQuery === 'undefined') {
            console.log('Waiting for jQuery...');
            setTimeout(initWishlistFix, 100);
            return;
        }
        
        if (typeof window.wishlist === 'undefined') {
            console.log('Waiting for window.wishlist...');
            setTimeout(initWishlistFix, 100);
            return;
        }
        
        console.log('All dependencies ready, applying wishlist fix...');
        
        // Remove any existing wishlist handlers to avoid conflicts
        jQuery(document).off('click', '[data-wishlist]');
        
        // Add new wishlist click handler
        jQuery(document).on('click', '[data-wishlist]', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            console.log('Wishlist clicked!');
            
            try {
                const $this = jQuery(this);
                const productId = $this.data('product-id');
                const productHandle = $this.data('wishlist-handle');
                
                console.log('Product data:', { productId, productHandle });
                
                if (!productId || !productHandle) {
                    console.error('Missing product data');
                    return;
                }
                
                // Get current wishlist
                let wishlist = localStorage.getItem('wishlistItem');
                wishlist = wishlist ? JSON.parse(wishlist) : [];
                
                const isInWishlist = wishlist.includes(productHandle);
                console.log('Is in wishlist:', isInWishlist);
                
                if (isInWishlist) {
                    // Remove from wishlist
                    wishlist = wishlist.filter(item => item !== productHandle);
                    $this.removeClass('wishlist-added');
                    
                    // Update text elements
                    const textElement = $this.find('.text');
                    if (textElement.length > 0) {
                        textElement.text(window.wishlist?.add || 'Add to Wishlist');
                    }
                    
                    const hiddenTextElement = $this.find('.visually-hidden');
                    if (hiddenTextElement.length > 0) {
                        hiddenTextElement.text(window.wishlist?.add || 'Add to Wishlist');
                    }
                    
                    console.log('Removed from wishlist:', productHandle);
                } else {
                    // Add to wishlist
                    wishlist.push(productHandle);
                    $this.addClass('wishlist-added');
                    
                    // Update text elements
                    const textElement = $this.find('.text');
                    if (textElement.length > 0) {
                        textElement.text(window.wishlist?.added || 'Added');
                    }
                    
                    const hiddenTextElement = $this.find('.visually-hidden');
                    if (hiddenTextElement.length > 0) {
                        hiddenTextElement.text(window.wishlist?.added || 'Added');
                    }
                    
                    console.log('Added to wishlist:', productHandle);
                }
                
                // Save to localStorage
                localStorage.setItem('wishlistItem', JSON.stringify(wishlist));
                
                // Update count
                jQuery('[data-wishlist-count]').text(wishlist.length);
                
                console.log('Wishlist updated:', wishlist);
                
            } catch (error) {
                console.error('Wishlist error:', error);
            }
        });
        
        // Initialize existing wishlist states
        function initializeExistingWishlist() {
            try {
                const wishlist = localStorage.getItem('wishlistItem');
                if (!wishlist) return;
                
                const wishlistItems = JSON.parse(wishlist);
                console.log('Initializing existing wishlist:', wishlistItems);
                
                wishlistItems.forEach(productHandle => {
                    const element = jQuery(`[data-wishlist-handle="${productHandle}"]`);
                    if (element.length > 0) {
                        element.addClass('wishlist-added');
                        
                        // Update text elements
                        const textElement = element.find('.text');
                        if (textElement.length > 0) {
                            textElement.text(window.wishlist?.added || 'Added');
                        }
                        
                        const hiddenTextElement = element.find('.visually-hidden');
                        if (hiddenTextElement.length > 0) {
                            hiddenTextElement.text(window.wishlist?.added || 'Added');
                        }
                    }
                });
                
                // Update count
                jQuery('[data-wishlist-count]').text(wishlistItems.length);
                
            } catch (error) {
                console.error('Error initializing wishlist:', error);
            }
        }
        
        // Initialize after a short delay
        setTimeout(initializeExistingWishlist, 200);
        
        // Reinitialize on AJAX complete
        jQuery(document).ajaxComplete(function() {
            setTimeout(initializeExistingWishlist, 100);
        });
        
        console.log('Simple wishlist fix applied!');
    }
    
    // Start initialization
    setTimeout(initWishlistFix, 500);
});
